import React, { useState } from 'react';
import '../styles/calculator.css';
import shadowLogo from '../assets/itiniri_shadow.png'; // Import the logo

const Calculator = () => {
  const [attendees, setAttendees] = useState(50); // Default value is the minimum (50)

  // Helper function to format numbers with commas
  const formatNumberWithCommas = (number) => {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); // Adds commas to the number
  };

  // Pricing Logic
  const yourPricing = attendees >= 51 ? attendees * 0.3 : 0; // Free for 50 or fewer attendees
  const schedPricing = attendees >= 51 ? attendees * 5.6 : 0; // Free for 50 or fewer attendees, $5.6 per attendee above 50
  const regFoxPricing = attendees * 0.99; // $0.99 per attendee
  const paperProgramPricing = attendees * 0.6; // $0.60 per attendee for Paper Programs

  // Helper Function to Format Costs (without cents)
  const formatCost = (cost, addPlus = false) =>
    attendees === 50 && (cost === yourPricing || cost === schedPricing)
      ? 'FREE'
      : `$${formatNumberWithCommas(Math.round(cost))}${addPlus ? '+' : ''}`;

      const handleSliderChange = (value) => {
        setAttendees(value);
      
        // Update the gradient of the slider dynamically
        const sliderElement = document.getElementById('attendees-range');
        const percentage = ((value - 50) / (20000 - 50)) * 100; // Calculate percentage of range traveled
        sliderElement.style.background = `linear-gradient(to right, #8ec7db ${percentage}%, #d3d3d3 ${percentage}%)`;
      };
      

  return (
    <div className="calculator-container">
      <h2>Event Cost Savings Calculator</h2>
      <p>Use the slider to select the number of attendees:</p>

      <div className="input-section">
        <label htmlFor="attendees">Attendees: {formatNumberWithCommas(attendees)}</label>
        <input
  type="range"
  id="attendees-range"
  min="50"
  max="20000"
  step="50" // Increments by 50
  value={attendees}
  onChange={(e) => handleSliderChange(Number(e.target.value))}
  className="slider"
/>

      </div>

      {/* Replace "Your Pricing" with the itiniri_shadow logo */}
      <div className="your-pricing">
        <img src={shadowLogo} alt="Itiniri Shadow Logo" className="shadow-logo" />
        <p>{formatCost(yourPricing)}</p>
      </div>

      <div className="results-row">
        <div className="result">
          <h3>Paper Programs</h3>
          <p>{formatCost(paperProgramPricing, true)}</p>
        </div>
        <div className="result">
          <h3>RegFox</h3>
          <p>{formatCost(regFoxPricing, true)}</p>
        </div>
        <div className="result">
          <h3>Sched</h3>
          <p>{formatCost(schedPricing, true)}</p>
        </div>
      </div>

      {/* Disclaimer */}
      <p className="disclaimer">Based off of pricing from competitor websites.</p>
    </div>
  );
};

export default Calculator;
